import Container from '@/shared/Container';
import Home from '../Icons/Home';
import Map from '../Map';
import Link from '@/shared/Link';
import Earnings from '../Icons/Earnings';
import Store from '../Icons/Store';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { SELLER_URLS } from '@/configs/constants';
import SCAOrders from '../Icons/SCAOrders';

const BOTTOM_NAVIGATION = [
  {
    id: 1,
    label: 'Home',
    url: SELLER_URLS.DASHBOARD,
    icon: Home,
  },
  {
    id: 2,
    label: 'My Store',
    url: SELLER_URLS.STORE,
    icon: Store,
  },
  {
    id: 3,
    label: 'Orders',
    url: SELLER_URLS.ORDERS,
    icon: SCAOrders,
  },
  {
    id: 4,
    label: 'Earnings',
    url: SELLER_URLS.EARNINGS,
    icon: Earnings,
  },
];

const getIsActive = (id: number, pathname: string) => {
  if (pathname == SELLER_URLS.DASHBOARD && id == 1) {
    return true;
  }
  if (pathname.startsWith(SELLER_URLS.EARNINGS) && id == 4) {
    return true;
  }
  if (pathname.startsWith(SELLER_URLS.STORE) && id == 2) {
    return true;
  }
  if (pathname.startsWith(SELLER_URLS.ORDERS) && id == 3) {
    return true;
  }
  return false;
};

const BottomNavigation = () => {
  const { pathname } = useRouter();

  const render = (item: any, i: number) => {
    const { label, url, icon, id } = item;
    const IconComponent = icon;

    let isActive = getIsActive(id, pathname);
    return (
      <Link
        href={url}
        key={id}
        className={classNames(
          'flex w-1/3 flex-col items-center justify-center text-callout-small',
          {
            'text-extended-efbrand': isActive,
            'text-neutral-200': !isActive,
          },
        )}
      >
        <IconComponent fillPath={isActive ? '#003594' : '#B3B3B3'} />
        {label}
      </Link>
    );
  };

  return (
    <nav className="fixed -bottom-[1px] left-0 right-0 bg-white shadow-subtle pt-s4 py-s5  z-40">
      <Container>
        <Map className="flex justify-between" list={BOTTOM_NAVIGATION} render={render} />
      </Container>
    </nav>
  );
};

export default BottomNavigation;
